import { SET_SUCCESS_MESSAGE, CLEAR_MESSAGE, SET_ERROR_MESSAGE } from 'actions/messages';

const defaultState = { content: null, visible: false, type: 'neutral', className: '' };

export default (state = defaultState, action) => {
  const { type, message, className } = action;
  switch (type) {
    case SET_SUCCESS_MESSAGE:
      return {
        ...state,
        content: message,
        type: 'success',
        visible: true,
        className: className || '',
      };
    case SET_ERROR_MESSAGE:
      return {
        ...state,
        content: message,
        type: 'error',
        visible: true,
        className: className || '',
      };
    case CLEAR_MESSAGE:
      return {
        ...state,
        visible: false,
        className: '',
      };
    default:
      return state;
  }
};

export const selectToastMessage = state => state.messages;
